import HeaderOther from "./header-other";

export default function PrivacyPolicy() {

    return (
        <>
            <HeaderOther />
            <div style={{margin:'10px'}}>
                <p style={{fontSize:'24px'}}>Privacy Policy for OnTimeUrban: The Instant Wholesaler</p>
                <p style={{fontSize:'16px', fontWeight:'500'}}>Effective Date: January 15, 2025</p>
                <p style={{fontSize:'14px'}}>
                    At OnTimeUrban, your privacy is of utmost importance to us. This Privacy Policy outlines how we collect,
                    use, and protect your information when you use our services. By using our website, mobile application, or
                    services, you agree to the terms of this Privacy Policy.
                </p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Information We Collect</p>
                <p style={{fontSize:'14px'}}>We collect the following types of information to provide and improve our services:</p>
                <p style={{fontSize:'16px'}}>a. Personal Information</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Name, email address, phone number, and delivery address when you register or place an order.</li>
                    <li>Payment information (e.g., card details) processed securely by third-party payment gateways.</li>
                </ul>
                <p style={{fontSize:'16px'}}>b. Usage Information</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Details of your interactions with our platform, such as order history and preferences.</li>
                    <li>Device information, including IP address, browser type, and operating system.</li>
                </ul>
                <p style={{fontSize:'16px'}}>c. Location Data</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Your real-time location to ensure accurate and timely delivery within Hazaribagh, Jharkhand.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>How We Use Your Information</p>
                <p style={{fontSize:'14px'}}>We use your information for the following purposes:</p>
                <ul style={{fontSize:'14px'}}>
                    <li>To process and deliver orders within 15 minutes or hours in Hazaribagh, Jharkhand.</li>
                    <li>To communicate with you regarding your orders, offers, and updates.</li>
                    <li>To personalize your shopping experience and recommend products.</li>
                    <li>To improve our services and resolve customer queries.</li>
                    <li>To comply with legal obligations and prevent fraudulent activities.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}> Sharing Your Information</p>
                <p style={{ fontSize: '14px' }}>We do not sell or rent your personal information to third parties. However, we may share your data with:</p>
                <ul style={{fontSize:'14px'}}>
                    <li><span style={{fontWeight:'500'}}>Delivery Partners:</span> To ensure prompt delivery of your orders.</li>
                    <li><span style={{fontWeight:'500'}}>Payment Gateways:</span> For secure transaction processing.</li>
                    <li><span style={{fontWeight:'500'}}>Service Providers:</span> For IT support, analytics, and customer support.</li>
                    <li><span style={{fontWeight:'500'}}>Legal Authorities:</span> If required by law or to protect our rights.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Data Security</p>
                <p style={{ fontSize: '14px' }}>We take appropriate measures to protect your personal information from unauthorized access,
                    alteration, or disclosure. This includes:</p>
                <ul style={{ fontSize: '14px' }}>
                    <li>Secure payment processing.</li>
                    <li>Regular security audits of our systems.</li>
                    <li>Restricted access to personal data for authorized personnel only.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Your Rights</p>
                <p style={{ fontSize: '14px' }}>You have the right to:</p>
                <ul style={{ fontSize: '14px' }}>
                    <li>Access and update your personal information.</li>
                    <li>Request deletion of your data (subject to legal obligations).</li>
                    <li>Opt-out of marketing communications by contacting us.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Cookies</p>
                <p style={{ fontSize: '14px' }}>We use cookies to enhance your browsing experience.
                    These cookies help us remember your preferences and provide tailored
                    recommendations. You can manage cookie preferences through your browser settings.</p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Children’s Privacy</p>
                <p style={{ fontSize: '14px' }}>Our services are not intended for children under 13 years of age.
                    We do not knowingly collect personal information from children.</p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Changes to This Policy</p>
                <p style={{ fontSize: '14px'}}>We may update this Privacy Policy from time to time. Any changes will be posted on this page,
                    and the effective date will be updated accordingly.</p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Contact Us</p>
                <p style={{ fontSize: '14px' }}>If you have any questions or concerns about this Privacy Policy, please contact us at:</p>
                <p style={{ fontSize: '14px', fontWeight: '500' }}>OnTimeUrban: The Instant Wholesaler</p>
                <p style={{ fontSize: '14px' }}><span style={{ fontWeight: '500' }}>Email:</span> ontimeurban@gmail.com</p>
                <p style={{ fontSize: '14px' }}><span style={{ fontWeight: '500' }}>Phone:</span> +91-7481016483</p>
                <p style={{ fontSize: '14px' }}><span style={{ fontWeight: '500' }}>Address:</span> Hazaribagh, Jharkhand, India</p>
            </div>
        </>
    );
}